export default __webpack_public_path__ + "static/media/no_feeds_message.7dc6edc0.svg";